import BaffleButton from '@nordinvestments/nord-storybook/dist/components/BaffleButton'
import ScrollTransition from '@nordinvestments/nord-storybook/dist/components/ScrollTransition'
import classNames from 'classnames'
import React from 'react'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'

import BaseSection from '../../../BaseSection'
import HeroShapesVideo from '../../../HeroShapesVideo'
import OnboardingLink from '../../../OnboardingLink'

import mp4Video from './media/privat.mp4'
import posterSrc from './media/privat.png'
import webmVideo from './media/privat.webm'
import styles from './PrivatHero.module.scss'

const PrivatHero = () => (
  <BaseSection.Hero
    backgroundClass={classNames('bg-nord-gradient', styles.privatHero)}
    withCut
  >
    <Row>
      <Col
        xs={12}
        lg={5}
        className="offset-lg-1 mt-4 mt-lg-0 my-lg-auto text-center text-lg-left"
      >
        <BaseSection.Header.HeroTop className="text-white" scrollReveal>
          Privat
        </BaseSection.Header.HeroTop>
        <BaseSection.Header.Base
          className="text-white"
          scrollReveal
          isHeroHeader
        >
          Investering med lave omkostinnger
        </BaseSection.Header.Base>
        <BaseSection.Text scrollReveal>
          Investér med en digital formueplejeløsning. Start med en gratis
          investeringsplan.
        </BaseSection.Text>
        <ScrollTransition.Item>
          <OnboardingLink
            component={BaffleButton}
            variant="success"
            path="privat"
          >
            Gratis Investeringsplan
          </OnboardingLink>
        </ScrollTransition.Item>
      </Col>
      <Col xs={12} lg={5} className="mt-5 mt-lg-0">
        <HeroShapesVideo
          variant="B"
          mp4Video={mp4Video}
          posterSrc={posterSrc}
          webmVideo={webmVideo}
        />
      </Col>
    </Row>
  </BaseSection.Hero>
)

export default PrivatHero
